module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-12-81d1ef2b3fe8f8115b77376fdcd52806.svg";